module.exports = __webpack_public_path__ + "img/special_liftserum_202403.0927fd9c.jpg";